import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Effettua il caricamento iniziale per verificare l'utente autenticato
    useEffect(() => {
        const checkUser = async () => {
            try {
                const token = localStorage.getItem("token");
                if (token) {
                    // Configura l'header di autorizzazione
                    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                    const response = await axios.get("https://adapt-api.softmining.it/users/me");
                    if (response.data) {
                        setUser(response.data); // Aggiorna lo stato dell'utente
                    }
                }
            } catch (error) {
                console.error("Errore nel recupero del profilo utente:", error);
                logout();
            } finally {
                setLoading(false);
            }
        };

        checkUser();
    }, []);

    const login = async (email, password) => {
        try {
            const response = await axios.post(
                "https://adapt-api.softmining.it/authenticate",
                { email, password },
                { headers: { "Content-Type": "application/json" } }
            );

            const { data } = response.data;
            if (data) {
                // Salva il token e configura l'header per le richieste successive
                localStorage.setItem("token", data);
                axios.defaults.headers.common["Authorization"] = `Bearer ${data}`;

                // Recupera il profilo dell'utente
                const profileResponse = await axios.get("https://adapt-api.softmining.it/users/me");
                if (profileResponse.data) {
                    setUser(profileResponse.data);
                }
            }
        } catch (error) {
            console.error("Errore durante il login:", error);
            throw new Error("Credenziali non valide");
        }
    };

    const signup = async (userData) => {
        try {
            const response = await axios.post(
                "https://adapt-api.softmining.it/",
                userData,
                { headers: { "Content-Type": "application/json" } }
            );

            const { data } = response.data;
            if (data) {
                // Salva il token e configura l'header per le richieste successive
                localStorage.setItem("token", data);
                axios.defaults.headers.common["Authorization"] = `Bearer ${data}`;
            }
        } catch (error) {
            console.error("Errore durante la registrazione:", error);
            throw new Error(error.response?.data?.message || "Errore durante la registrazione");
        }
    };

    const logout = async () => {
        try {
            // Rimuovi il token e resetta lo stato
            localStorage.removeItem("token");
            delete axios.defaults.headers.common["Authorization"];
            setUser(null);
        } catch (error) {
            console.error("Errore durante il logout:", error);
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, signup, logout }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
